export default __webpack_public_path__ + "static/skattefritt-pa-svenska-casino-3c2b1e98d98e22c2148abbabb5dafd74.jpg";